/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
*/

import {GraphqlResponse} from '../../data/interfaces';
import {
    FETCH_GRAPHQL_REQUEST,
    FETCH_GRAPHQL_FAILURE,
    FETCH_GRAPHQL_SUCCESS,
} from "../types/api";
import { GraphqlActions } from '../types/graphqlResponse';

interface GraphqlResponseState {
    graphqlInfo: GraphqlResponse,
    error: string,
    loading: boolean,
}

const initialState: GraphqlResponseState = {
    graphqlInfo: {environments: [{organizationUuid:" ", orgShared:true, name:" ", description:" ", id:" ", templateId:"", vhost: " ", choreoEnv:" ", projectId:" ", promoteFrom:[" "], namespace:" ", externalApiEnvName:" "}]},
    error: '',
    loading: false,
}

const graphqlReducer = (state = initialState, action: GraphqlActions) => {
    switch (action.type) {
        case FETCH_GRAPHQL_REQUEST:
            return {
                ...state,
                loading: true,
                error: ''
            }
        case FETCH_GRAPHQL_SUCCESS:
            return {
                ...state,
                loading: false,
                graphqlInfo: action.payload
            }
        case FETCH_GRAPHQL_FAILURE:
            return {
                ...state,
                loading: false,
                graphqlInfo: { data: {environments: []}},
                error: action.payload
            }
        default: return state
    }
}

export default graphqlReducer;
